import React from 'react';
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import {
    ConfigurationsDashboard,
    UserManagement,
    SystemSettings,
    LabSettings,
    SecuritySettings,
    QASettings,
    ClientSettings,
    GeneralSettings,
    QuickBooksIntegration,
    OnboardingManagement
} from "./config-sections";
import styles from './Configurations.module.css';

const Configurations = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isAuthenticated = useIsAuthenticated();

    if (!isAuthenticated) {
        return (
            <div className={styles.container}>
                <h2>Access Denied</h2>
                <p>Please sign in to access the configurations.</p>
            </div>
        );
    }

    // Extract current section from pathname for breadcrumb
    const getBreadcrumbItems = () => {
        const path = location.pathname;
        if (path === '/configurations') return ['Configurations'];
        if (path === '/configurations/users') return ['Configurations', 'User Management'];
        if (path === '/configurations/system') return ['Configurations', 'System Settings'];
        if (path === '/configurations/lab') return ['Configurations', 'Lab Settings'];
        if (path === '/configurations/security') return ['Configurations', 'Security Settings'];
        if (path === '/configurations/qa') return ['Configurations', 'QA Settings'];
        if (path === '/configurations/clients') return ['Configurations', 'Client Settings'];
        if (path.startsWith('/configurations/clients')) return ['Configurations', 'Client Settings'];
        if (path === '/configurations/quickbooks') return ['Configurations', 'QuickBooks Integration'];
        if (path.startsWith('/configurations/onboarding')) return ['Configurations', 'Client Onboarding'];
        if (path.startsWith('/configurations/general')) return ['Configurations', 'General Settings'];
        if (path.startsWith('/configurations/general/note-types')) return ['Configurations', 'General Settings', 'Note Types'];
        return ['Configurations'];
    };

    const breadcrumbItems = getBreadcrumbItems();
    const isOnDashboard = location.pathname === '/configurations';

    return (
        <div className={styles.configurations}>
            <div className={styles.header}>
                <h1>Configurations</h1>
                <nav className={styles.breadcrumb}>
                    {breadcrumbItems.map((item, index) => (
                        <span key={index}>
                            {index === 0 ? (
                                <button 
                                    className={`${styles.breadcrumbItem} ${isOnDashboard ? styles.active : ''}`}
                                    onClick={() => navigate('/configurations')}
                                >
                                    {item}
                                </button>
                            ) : index === breadcrumbItems.length - 1 ? (
                                <span className={`${styles.breadcrumbItem} ${styles.active}`}>
                                    {item}
                                </span>
                            ) : (
                                <button 
                                    className={styles.breadcrumbItem}
                                    onClick={() => navigate('/configurations')}
                                >
                                    {item}
                                </button>
                            )}
                            {index < breadcrumbItems.length - 1 && (
                                <span className={styles.breadcrumbSeparator}>›</span>
                            )}
                        </span>
                    ))}
                </nav>
            </div>

            <div className={styles.content}>
                <Routes>
                    <Route index element={<ConfigurationsDashboard />} />
                    <Route path="users" element={<UserManagement />} />
                    <Route path="system" element={<SystemSettings />} />
                    <Route path="lab" element={<LabSettings />} />
                    <Route path="security" element={<SecuritySettings />} />
                    <Route path="qa" element={<QASettings />} />
                    <Route path="clients/*" element={<ClientSettings />} />
                    <Route path="general/*" element={<GeneralSettings />} />
                    <Route path="quickbooks" element={<QuickBooksIntegration />} />
                    <Route path="onboarding/*" element={<OnboardingManagement />} />
                </Routes>
            </div>
        </div>
    );
};

export default Configurations;
